import React from 'react';
import { Briefcase, MessageSquare, Book, Users } from 'lucide-react';
import { Card } from './ui/card';

const Work = () => {
  return (
    <section id="work" className="py-24 px-6 bg-gradient-to-br from-purple-100 via-pink-100 to-orange-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-gray-900 mb-4">Areas of Expertise</h2>
          <div className="w-20 h-1 bg-gradient-to-r from-teal-500 via-purple-500 to-pink-500 mx-auto mb-6"></div>
          <p className="text-lg text-gray-700 max-w-2xl mx-auto">
            Delivering excellence across multiple domains to drive organizational success and community impact.
          </p>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          <Card className="p-8 hover:shadow-2xl transition-all duration-300 bg-white border-t-4 border-teal-500 hover:-translate-y-2">
            <div className="w-14 h-14 bg-gradient-to-br from-teal-400 to-teal-600 rounded-lg flex items-center justify-center mb-6">
              <Briefcase className="h-7 w-7 text-white" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-4">Program & Project Leadership</h3>
            <p className="text-gray-600 leading-relaxed">
              Designing and implementing strategic programs that drive sustainable growth and measurable impact across organizations.
            </p>
          </Card>
          <Card className="p-8 hover:shadow-2xl transition-all duration-300 bg-white border-t-4 border-purple-500 hover:-translate-y-2">
            <div className="w-14 h-14 bg-gradient-to-br from-purple-400 to-purple-600 rounded-lg flex items-center justify-center mb-6">
              <MessageSquare className="h-7 w-7 text-white" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-4">Business Consulting & Strategy</h3>
            <p className="text-gray-600 leading-relaxed">
              Providing strategic guidance to businesses and entrepreneurs, helping them navigate challenges and achieve their goals.
            </p>
          </Card>
          <Card className="p-8 hover:shadow-2xl transition-all duration-300 bg-white border-t-4 border-pink-500 hover:-translate-y-2">
            <div className="w-14 h-14 bg-gradient-to-br from-pink-400 to-pink-600 rounded-lg flex items-center justify-center mb-6">
              <Book className="h-7 w-7 text-white" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-4">Research & Organizational Development</h3>
            <p className="text-gray-600 leading-relaxed">
              Conducting meaningful research and developing organizational capabilities that foster innovation and excellence.
            </p>
          </Card>
          <Card className="p-8 hover:shadow-2xl transition-all duration-300 bg-white border-t-4 border-orange-500 hover:-translate-y-2">
            <div className="w-14 h-14 bg-gradient-to-br from-orange-400 to-orange-600 rounded-lg flex items-center justify-center mb-6">
              <Users className="h-7 w-7 text-white" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-4">Community & Youth Leadership</h3>
            <p className="text-gray-600 leading-relaxed">
              Empowering communities and mentoring young leaders to create positive change and build brighter futures.
            </p>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default Work;